// 🧮 Format MM:SS
export const formatTime = (t) => {
    const m = Math.floor(t / 60)
        .toString()
        .padStart(2, "0");
    const s = (t % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
};